import { Injectable } from '@angular/core';
import { OneClickState } from '@ordersnproducts/modules/one-click-order/reducers';
import { ILegalEntity } from '@cemex-core/cmx-api';
import { ONE_CLICK_PROFILE_CONSTANTS } from '@ordersnproducts/modules/one-click-order/constants/one-click-profile-state';
import { DraftProduct } from '@cemex-core/cmx-api/models/drafts/model/draft-product';
import { getProductId } from '@ordersnproducts/modules/order-builder/modules/specification/helpers/product.helper';
import * as moment from 'moment';
import { ifElse, path, pathOr } from 'ramda';

@Injectable()
export class OneClickDraftService {
  constructor() {}
  public createRequest(state: OneClickState, customer: ILegalEntity, orderTypeCode: string) {
    const createDraftRequest = {
      orderName: ONE_CLICK_PROFILE_CONSTANTS.orderName,
      requestedDateTime: this.nextDay().toISOString(),
      purchaseOrder: '',
      customer: {
        customerId: customer.legalEntityId,
      },
      shippingCondition: {
        shippingConditionId: state.shippingMethodsState.selected.shippingConditionId,
        shippingConditionCode: state.shippingMethodsState.selected.shippingConditionCode,
        shippingConditionDesc: state.shippingMethodsState.selected.shippingConditionDesc,
      },
      jobsite: {
        jobsiteId: state.jobsiteState.selected.jobsite.jobsiteId,
      },
      orderType: {
        orderTypeId: ONE_CLICK_PROFILE_CONSTANTS.orderTypeId,
        orderTypeCode: orderTypeCode,
        orderTypeDesc: ONE_CLICK_PROFILE_CONSTANTS.orderTypeDesc,
        commercialChannelCode: ONE_CLICK_PROFILE_CONSTANTS.commercialChannelCode,
      },
      instructions: '',
      contact: null,
      items: state.productsState.selected.map((item, index) => {
        return this.createDraftProduct(state, index);
      }),
    };

    // TODO: WIP CX018GO1905-832
    if (state.jobsiteState.salesArea !== null && state.jobsiteState.salesArea !== undefined) {
      createDraftRequest['salesArea'] = {
        salesAreaId: state.jobsiteState.salesArea.salesArea.salesAreaId,
        businessLine: {
          businessLineCode: ifElse(
            path(['state', 'businessLinesState', 'selected']),
            path(['state', 'businessLinesState', 'selected', 'productLineCode']),
            pathOr(null, [
              'state',
              'profileState',
              'presetOrder',
              'items',
              0,
              'product',
              'productType',
              'productTypeCode',
            ]),
          )(state),
        },
      };
    }

    if (state.pointOfDeliveriesState.selected && state.pointOfDeliveriesState.selected) {
      createDraftRequest['pointOfDelivery'] = {
        pointOfDeliveryId: state.pointOfDeliveriesState.selected.shippingDestinationId,
      };
    }

    return createDraftRequest;
  }

  private createDraftProduct(state: OneClickState, index: number): DraftProduct {
    const productId = getProductId(state.productsState.selected[index]);
    const req: DraftProduct = {
      itemSeqNum: ONE_CLICK_PROFILE_CONSTANTS.itemSeqNum * (index + 1),
      purchaseOrder: null,
      requestedDateTime: this.nextDay().toISOString(),
      currency: {
        currencyCode: ONE_CLICK_PROFILE_CONSTANTS.currencyCode,
      },
      quantity: state.quantityState.value[index] ? state.quantityState.value[index] : state.quantityState.value[0],
      product: {
        productId,
      },
      uom: {
        unitId: this.retrieveUnit(state),
      },
      orderItemProfile: {},
    };

    if (state.paymentsState.selected[index]) {
      req.paymentTerm = {
        paymentTermId: Number(state.paymentsState.selected[index]),
      };
    } else {
      req.paymentTerm = {
        paymentTermId: state.jobsiteState.selected.paymentTerm.paymentTermId,
      };
    }

    if (state.plansState.selected[index]) {
      req.shippingSource = {
        shippingSourceId: Number(state.plansState.selected[index]),
      };
    }

    if (state.jobsiteState.stdLot) {
      req['lot'] = {
        lotMin: state.jobsiteState.stdLot.lotMin,
        conversionFactor: 1,
      };
    }

    return req;
  }

  private nextDay() {
    return moment()
      .add(1, 'days')
      .toDate();
  }

  public retrieveUnit(state: OneClickState) {
    if (state.unitsSate.selected) {
      return state.unitsSate.selected.alternativeUnit.unitId;
    } else {
      return Number(state.jobsiteState.salesArea.maximumLot.unitOfMeasure.unitId);
    }
  }
}
